export const HomePageExplore = [
    {
        tag: 'Free',
        courses : [
            {
                heading : "Learn HTML",
                description : "This course covers the basic concepts of HTML including creating and structuring web pages, adding text, links, images, and more.",
                level : 'Beginner',
                lessionNumber : 6
            },
            {
                heading : "Learn CSS",
                description : "This course explores advanced topics in HTML5 and CSS3, including animations, transitions, and layout techniques",
                level : 'Beginner',
                lessionNumber : 6
            },
            {
                heading : "Responsive Web design",
                description : "This course teaches responsive web design techniques, allowing web pages to adapt to different devices and screen sizes",
                level : 'Beginner',
                lessionNumber : 6
            },
        ]
    },
    {
        tag: 'New to coding',
        courses : [
            {
                heading : "HTML",
                description : "Learn HTML essentials in this comprehensive course. Master fundamental tags, structure, and semantic elements for creating web pages. Dive into forms, multimedia embedding, and links. Explore best practices for accessibility and SEO.",
                level : 'Beginner',
                lessionNumber : 6
            },
            {
                heading : "CSS",
                description : "Unlock the power of CSS with this concise course. Explore selectors, properties, and values to style web pages beautifully. Delve into layout techniques, including flexbox and grid. Learn to create responsive designs and animations. ",
                level : 'Beginner',
                lessionNumber : 6
            },
            {
                heading : "Responsive ",
                description : "Discover the art of responsive design in this dynamic course. Learn to craft websites that adapt seamlessly to various devices and screen sizes. Explore CSS media queries, flexible grids, and fluid images. ",
                level : 'Beginner',
                lessionNumber : 6
            },
        ]
    },
    {
        tag: 'Most popular',
        courses : [
            {
                heading : "Java",
                description : "From basic syntax to advanced concepts like multithreading and data structures, delve into object-oriented programming principles. Gain practical experience through hands-on projects, mastering Java's versatility for web development, mobile apps, and enterprise solutions.",
                level : 'Beginner',
                lessionNumber : 6
            },
            {
                heading : "Python",
                description : "Master Python essentials swiftly! Learn fundamental syntax, data structures, and control flow. Dive into object-oriented programming and harness Python's versatility for web development, data analysis, and automation",
                level : 'Beginner',
                lessionNumber : 6
            },
            {
                heading : "SCSS",
                description : "Discover SCSS essentials: variables, nesting, mixins, and inheritance. Elevate CSS with modular, maintainable stylesheets. Harness SCSS power for efficient styling and streamlined CSS development workflows.",
                level : 'Beginner',
                lessionNumber : 6
            },
        ]
    },
    {
        tag: 'Skills paths',
        courses : [
            {
                heading : "Flask",
                description : "Unlock Flask: Python web framework mastery. Build dynamic web applications with ease. Learn routing, templates, database integration, and RESTful APIs. Launch your web projects confidently with Flask expertise.",
                level : 'Beginner',
                lessionNumber : 6
            },
            {
                heading : "Django",
                description : "Develop full-stack web applications with Django's clean architecture, ORM, authentication, and RESTful APIs. Become proficient in building robust, scalable web projects with Django.",
                level : 'Beginner',
                lessionNumber : 6
            },
            {
                heading : "Fast API",
                description : "Learn FastAPI: Python's modern, fast (high-performance), web framework for building APIs with minimal code. Utilize async capabilities, automatic docs generation, and type checking for efficient API development.",
                level : 'Beginner',
                lessionNumber : 6
            },
        ]
    },
    {
        tag: 'Career paths',
        courses : [
            {
                heading : "Next.js",
                description : "Next.js Mastery: Harness the power of React with server-side rendering, static site generation, and seamless routing. Learn to build high-performance web applications with Next.js, enabling rapid development and SEO optimization.",
                level : 'Beginner',
                lessionNumber : 6
            },
            {
                heading : "Nuxt.js",
                description : "Master Nuxt.js: The Vue.js framework enabling server-side rendering, single-page applications, and static site generation. Explore its intuitive features for fast and scalable web development with Vue.js.",
                level : 'Beginner',
                lessionNumber : 6
            },
            {
                heading : "Sanity",
                description : "Sanity.io Essentials: Master headless CMS development with Sanity.io. Learn to build customizable, scalable content platforms with real-time collaboration and powerful APIs for modern web applications in this comprehensive course.",
                level : 'Beginner',
                lessionNumber : 6
            },
        ]
    },
]